export const attributeNameLabelMap: {
  [key: string]: string;
} = {
  "Phone number": "Phone Number",
  Email: "Email",
  "First Name": "First Name",
  "Last Name": "Last Name",
  Status: "Status",
  "Status Reason": "Status reason",
  "Total Send": "Total Send",
  "Total Opens": "Total Opens",
  "Total Clicked": "Total Clicked",
  "Total Delivered": "Total Delivered",
  "Updated At": "Updated Time",
  "Created At": "Created Time",
  Birthday: "Birthday",
  Tags: "Tags",
  Source: "Source",
  Currency: "Currency",
  Company: "Company",
  "Address 1": "Address Line 1",
  "Address 2": "Address Line 2",
  City: "City",
  "State/Province": "State/Province",
  Country: "Country",
  "Zip/Postal Code": "Zip/Postal code",
  Timezone: "Timezone",
  "Accepts Marketing": "Accepts Marketing",
  "Lifetime Value": "Lifetime Value ($)",
  "Number of orders": "Number of Orders",
  "Latest order ID": "Latest Order ID",
  "Last purchased order": "Last Purchased Order",
  "Last purchased price": "Last Order Price",
  "Last purchased date": "Last Order Date",
  UTM: "UTM",
};

export const defaultColumns = ["First Name", "Last Name", "Email", "Status"];
export const otherColumns = [
  "Phone number",
  "Total Send",
  "Total Opens",
  "Total Clicked",
  "Total Delivered",
  "Source",
  "Birthday",
  "Tags",
  "Company",
  "Currency",
  "Address 1",
  "Address 2",
  "City",
  "State/Province",
  "Country",
  "Zip/Postal Code",
  "Timezone",
  "Accepts Marketing",
  "Lifetime Value",
  "Number of orders",
  "Latest order ID",
  "Last purchased order",
  "Last purchased price",
  "Last purchased date",
  "Created At",
  "Updated At",
  "UTM",
];
